import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoiceLow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVoiceLow"><Path d="M7.5 6.5V17.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 11V13" stroke="currentColor" strokeLinecap="square"/><Path d="M12 10.5V13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 8.5V15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 11V13" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVoiceLow;
